import Entity from '../entity'

export default class WorkshopInfo extends Entity<number>{
    user_code: string;
    gto_code: string;
    treatment: string;
    employee_id: number;
    role_lc_id: number;
    role_tm_id: number;
    state_id: number;
    country_id: number;
    dealer_id: number;
    function_id: number;
    manufacturer: string;
    unity: string;
    phone: string;
    movil: string;
    telefax: string;
    email: string;
    username: string;
    bithdate: string;
    pdi: string;
    seller_code: string;
    active: boolean;
}


